import Vue from 'vue'
import * as actionTypes from '@/store/action-types'
import * as getTypes from '@/store/get-types'
import * as mutationTypes from '@/store/mutation-types'
import { WalletApi } from '@/cowboy/wallet/WalletApi'

const state = {
  isAuthenticated: false,
  recipientDetails: {
    identifier: null,
    emails: []
  },
  signupComplete: false
}

const getters = {
  [getTypes.GET_IS_AUTHENTICATED]: ({ isAuthenticated }) =>
    Boolean(isAuthenticated),
  [getTypes.GET_IS_SIGNUP_COMPLETE]: ({ signupComplete }) =>
    Boolean(signupComplete),
  [getTypes.GET_RECIPIENT_DETAILS]: ({ recipientDetails }) => recipientDetails
}

const actions = {
  [actionTypes.CLEAR_RECIPIENT_DETAILS]: async ({ commit }) => {
    commit(mutationTypes.SET_RECIPIENT_DETAILS, {})
  },
  [actionTypes.FETCH_RECIPIENT_DETAILS]: async ({ commit }) => {
    try {
      const recipientDetails = await WalletApi.getRecipientDetails()
      commit(mutationTypes.SET_RECIPIENT_DETAILS, recipientDetails)
    } catch (error) {
      console.error('Error fetching recipient details', error)
      commit(mutationTypes.SET_RECIPIENT_DETAILS, {})
    }
  },
  [actionTypes.LOGIN]: async ({ dispatch, commit }, credentials) => {
    try {
      await WalletApi.login(credentials.emailAddress, credentials.password)
      await dispatch(actionTypes.FETCH_RECIPIENT_DETAILS)
      commit(mutationTypes.SET_IS_AUTHENTICATED, true)
    } catch (error) {
      console.error('Invalid login attempt')
      commit(mutationTypes.SET_IS_AUTHENTICATED, false)
    }
  },
  [actionTypes.REGISTER_RECIPIENT]: async (context, credentials) => {
    await WalletApi.registerRecipient(credentials)
  },
  [actionTypes.REFRESH_AUTH_TOKEN]: async ({ state, commit, dispatch }) => {
    try {
      await WalletApi.tokenRefresh()
      if (!state.isAuthenticated) {
        await dispatch(actionTypes.FETCH_RECIPIENT_DETAILS)
        if (!state.isAuthenticated) {
          commit(mutationTypes.SET_IS_AUTHENTICATED, true)
        }
      }
    } catch (error) {
      await dispatch(actionTypes.CLEAR_RECIPIENT_DETAILS)
      commit(mutationTypes.SET_IS_AUTHENTICATED, false)
    }
  },
  [actionTypes.DELETE_RECIPIENT_WALLET]: async ({ commit, dispatch }) => {
    try {
      await WalletApi.deleteRecipientWallet()
      await dispatch(actionTypes.CLEAR_RECIPIENT_DETAILS)
      commit(mutationTypes.SET_IS_AUTHENTICATED, false)
      commit(mutationTypes.SET_SIGNUP_COMPLETE, false)
    } catch (error) {
      console.error('Error with delete')
    }
  }
}

const mutations = {
  [mutationTypes.SET_IS_AUTHENTICATED]: (state, isAuthenticated) => {
    state.isAuthenticated = Boolean(isAuthenticated)
  },
  [mutationTypes.SET_RECIPIENT_DETAILS]: (state, recipientDetails) => {
    const { identifier, emails, signupComplete } = recipientDetails || {}

    state.recipientDetails.identifier = identifier || null
    state.signupComplete = Boolean(signupComplete)

    Vue.set(state.recipientDetails, 'emails', emails || [])
  },
  [mutationTypes.SET_SIGNUP_COMPLETE]: (state, signupIsComplete) => {
    state.signupComplete = Boolean(signupIsComplete)
  }
}

export default { state, getters, actions, mutations }
